export default __webpack_public_path__ + "static/media/merchant-login.d656a0e8.png";